import styled from "styled-components";

const List = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;

  @media (max-width: 991px) {
    flex-wrap: wrap;
    width: 33%;
    justify-content: center;
    text-align: center;
  }
  @media (max-width: 575px) {
    flex-wrap: wrap;
    width: 33%;
    justify-content: center;
    text-align: center;
  }
`;

export default List;
